import { useContext, createContext, useState } from "react";
import { useNavigate } from "react-router-dom";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [email, setEmail] = useState(null);
    const [contact, setContact] = useState(null);
    const [role, setRole] = useState(null);
    const [token, setToken] = useState(localStorage.getItem("site") || "");
    const navigate = useNavigate();

    const loginAction = async (data) => {
        try {
            const response = await fetch(apiBaseUrl + "/auth/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });
            const res = await response.json();            
            if (res) {
                if (res.status === 200)
                {
                    if(res.result.role === "Admin")
                    {
                        setUser(res.result.username);
                        setEmail(res.result.email);
                        setContact(res.result.contact);
                        setRole(res.result.role);
                        setToken(res.token);
                        localStorage.setItem("site", res.token);
                        navigate("/dashboard");
                        
                    }
                    else
                    {
                        alert("You dont have rights to access this portal");
                        console.error("You dont have rights to access this portal");
                    }
                    return;
                }
                else{
                    alert(res.detail);
                    return;
                }
            }
            throw new Error(res.detail);
        } catch (err) {
            console.error(err);
        }
    };

    const logOut = () => {
        console.log("logout called");
        setUser(null);
        setEmail(null);
        setContact(null);
        setRole(null);
        setToken("");
        localStorage.removeItem("site");
        navigate("/login");
    };

    return (
        <AuthContext.Provider value={{ token, user, email, contact, role, loginAction, logOut }}>
            {children}
        </AuthContext.Provider>
    );

};

export default AuthProvider;

export const useAuth = () => {
    return useContext(AuthContext);
};